// velocity.js
import React, { useState } from "react";
import SharedHelmet from ".././Helmet";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Kecepatan - Cara Menghitung Kecepatan";
const DESCRIPTION = "Kalkulator kecepatan menghitung kecepatan berdasarkan jarak dan waktu.";
const KEYWORDS =
  "menghitung kecepatan, kalkulator kecepatan, menghitung kecepatan berdasarkan jarak dan waktu";
const OG_URL = "https://do-calculate.com/calculator/id/velocity";
function VelocityCalculator() {
  const [distance, setDistance] = useState("");
  const [time, setTime] = useState("");
  const [velocity, setVelocity] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!distance || !time) {
      setError("Harap masukkan jarak dan waktu dengan benar");
      setVelocity("");
      return;
    }
    const distanceValue = parseFloat(distance);
    const timeValue = parseFloat(time);
    if (isNaN(distanceValue) || isNaN(timeValue) || timeValue <= 0) {
      setError("Harap masukkan nilai yang valid dan positif untuk jarak dan waktu");
      setVelocity("");
      return;
    }
    const velocityValue = distanceValue / timeValue;
    setVelocity(velocityValue.toFixed(2));
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />         </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator ini membantu Anda menghitung kecepatan berdasarkan jarak dan waktu.
                  Untuk menghitung kecepatan, masukkan jarak tempuh (dalam kilometer)
                  dan waktu (dalam jam).
                </p>
                <p>Rumus menghitung kecepatan adalah:</p>
                <p>
                  <b>
                    Kecepatan (kilometer/jam) = Jarak (kilometer) / Waktu (jam)
                  </b>
                </p>
                <p>
                  Setelah memasukkan nilai yang sesuai, klik tombol "Hitung Kecepatan" untuk mendapatkan
                  hasil.
                </p>
              </div>
            </div>
               <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div >
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          Jarak (kilometer)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="80"
                        value={distance}
                        onChange={(e) => setDistance(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">Waktu (jam)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="8"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Hitung Kecepatan
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        Kesalahan: {error}
                      </p>
                    ) : (
                      <>
                        {velocity !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              Kecepatan (kilometer/jam): {velocity}
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              Langkah-langkah penyelesaian: <br />- Hitung kecepatan berdasarkan
                              rumus berikut: Kecepatan (kilometer/jam) = Jarak
                              (kilometer) / Waktu (jam)
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <RelatedLinks />           </div>
        </div>
        <div className="col">
          <SecondAds />           <br />
          <MainCalculatorsList></MainCalculatorsList>
                     <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default VelocityCalculator;